webpackJsonp([80],{

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1324);


/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _enCa = __webpack_require__(770);

var _enCa2 = _interopRequireDefault(_enCa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-ca', _enCa2.default);

/***/ })

},[1323]);


// WEBPACK FOOTER //
// app/datetime.en-ca-b543b64b2dcfa7c5d141.js